import { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNotify, useRecordContext } from "react-admin";
import { IfCanAccess } from "@react-admin/ra-rbac";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { BASE_API_URL } from "../../../config/configUrl";
import { getAccessToken } from "../../../admin/authProvider";

const fetchStatementPdf = (id: string | number) =>
  fetch(`${BASE_API_URL}/gasstation/statements/${id}/pdf`, {
    method: "GET",
    credentials: "include",
    headers: new Headers({
      Authorization: `Bearer ${getAccessToken()}`,
    }),
  }).then(async (response) => {
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || response.statusText);
    }
    return response.blob();
  });

function DownloadPdfAction() {
  const { t }: { t: any } = useTranslation();
  const record = useRecordContext();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);

  if (!record) return null;

  const handleDownload = async () => {
    setLoading(true);
    try {
      const blob = await fetchStatementPdf(record.id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `statement-${record.id}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      notify(`${t("Action failed")}: ${error.message}`, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <IfCanAccess action="pdf" resource="gasStationStatements">
      <Button
        variant="outlined"
        startIcon={loading ? <CircularProgress size={16} /> : <PictureAsPdfOutlinedIcon />}
        disabled={loading}
        onClick={handleDownload}
      >
        {t("Download PDF")}
      </Button>
    </IfCanAccess>
  );
}

export default DownloadPdfAction;
